import MyHeader from '../../Home/MyHeader';
import {ConfigProvider} from 'antd';
import MyFooter from '../../Home/MyFooter';
import img1 from '../../resource/news_3_img_1.jpg';
import '../NewsStyles.css';

export default function Index() {
  return (
    <ConfigProvider
      theme={{
        components: {
          Menu: {
            horizontalItemSelectedBg: '#ffffff',
            horizontalItemSelectedColor: '#203864',
            itemColor: '#203864',
            itemPaddingInline: 24,
            activeBarHeight: 0,
          },
          Collapse: {
            contentPadding: 0
          }
        },
      }}
    >
      <MyHeader/>
      <main className="news-room-body">
        <div className="new-room-content">
          <h1>异格技术完成数亿元A轮融资</h1>
          <p className="news-room-date">2025年2月</p>
          <img src={img1} alt="Eagle Chip"/>
          <br/>
          <p>
            2026年2月，异格技术完成数亿元 A 轮融资，引入园丰资本、中鑫资本、临港前沿等新投资方，中博聚力、博将资本、永鑫方舟资本等既有股东继续参投，晨联投资所管基金也参与本轮追加投资。
          </p>
          <p>
            异格技术成立于2022年，总部位于苏州，专注于国产高端 FPGA 芯片和专用 EDA 工具链的研发与设计。在中国 FPGA
            需求占全球市场近三分之二的大背景下，异格技术致力于填补中国在高端 FPGA 领域的空白。
          </p>
          <p>
            2023年9月，异格技术首颗 FPGA 测试芯片成功点亮。2024年9月，ECH 和 ECM 两个系列的首款 FPGA
            芯片成功点亮，同年11月正式发布面向客户的全自研可编程软件工具套件-Omni Design
            Suite。2025年9月，公司首款量产芯片P1成功量产，标志着公司从技术验证阶段进入商业化阶段。公司第二款自研高端 FPGA
            芯片近期即将回片，该芯片面向通信、数据中心、工业控制等关键领域，有望成为国产高端 FPGA 市场的重要突破节点。
          </p>
        </div>
      </main>
      <MyFooter/>
    </ConfigProvider>
  );
}